import styled from "styled-components";
import Text from "./Text";

const Paragraph = styled(Text).attrs({ as: "p" })`
  display: block;
  margin: 0.5em 0;
`;

export default Paragraph;
